import React, { useEffect, useState } from "react";
import Avatar from '../@vuexy/avatar/AvatarComponent'
import { User } from "react-feather"

function GetInitials(name) {
    let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
    let initials = [...name.matchAll(rgx)] || [];
    return ((initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')).toUpperCase();
}

/*export default class Color extends React.Component {
    state = {
        content: this.props.content ? this.props.content : null,
        color: this.props.color ? this.props.color : 'success',
        size: this.props.size ? this.props.size : 'md',
        id: this.props.id ? this.props.id : 'dopicistim',
    };

    componentDidUpdate(prevProps, prevState) {
        var update = false;
        var content = this.state.content;
        var color = this.state.color;
        var size = this.state.size;
        var id = this.state.id;

        if (prevProps.content !== this.props.content ) { update = true; content = this.props.content ? this.props.content : null; }
        if (prevProps.color !== this.props.color ) { update = true; color = this.props.color ? this.props.color : 'success'; }
        if (prevProps.size !== this.props.size ) { update = true; size = this.props.size ? this.props.size : 'md'; }
        if (prevProps.id !== this.props.id ) { update = true; id = this.props.id ? this.props.id : null; }

        if (update) this.setState({ content: content, color: color, size: size, id: id });
      }

    render() {
        const path = process.env.PUBLIC_URL + '/avatar/' + (this.state.id ?? '');
        let avatarExist = false;

        if (this.state.id) {
            const fs = require('fs')

            try {
                avatarExist = fs.existsSync(path);
            } catch(err) {
                console.error(err)
            }
        }

        console.log(this.state.id);
        console.log(this.props.id);
        return (
            <React.Fragment>
                {avatarExist && <Avatar className={this.props.className} img={path} size={this.state.size} />}
                {!avatarExist && this.state.content !== null && <Avatar id={this.state.id} className={this.props.className} color={this.state.color} content={GetInitials(this.state.content)} size={this.state.size} />}
                {!avatarExist && this.state.content === null && <Avatar id={this.state.id} className={this.props.className} icon={<User />} size={this.state.size} />}
            </React.Fragment>
        )
    }
}*/


function Color({
    id: id = null,
    className: className = '',
    userID: userID = null,
    content: content = null,
    color: color = 'primary',
    size: size = 'md'
}) {
    const PATH = process.env.PUBLIC_URL + '/avatar/' + (userID ?? '');
    const [avatarExist, setAvatarExist] = useState(false);
    
    useEffect(() => {
        if (userID) {
            const fs = require('fs');

            try {
                setAvatarExist(fs.existsSync(PATH));
            } catch(err) {
                console.error(err);
            }
        }
     }, [userID])

    return (
        <React.Fragment>
            {avatarExist && <Avatar className={className} img={PATH} size={size} />}
            {!avatarExist && content !== null && <Avatar id={id} className={className} color={color} content={GetInitials(content)} size={size} />}
            {!avatarExist && content === null && <Avatar id={id} className={className} icon={<User />} size={size} />}
        </React.Fragment>
    );
}

export default Color;